import { render, staticRenderFns } from "./cr.vue?vue&type=template&id=6a1aae11&scoped=true&"
import script from "./cr.vue?vue&type=script&lang=js&"
export * from "./cr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1aae11",
  null
  
)

export default component.exports